// Source unique d'identité du module PROGÈRE (Design System universel).
// Ne jamais réécrire le nom du module en dur ailleurs — importer depuis ce fichier.
export const PROGERE_MODULE = {
  code: "punch",
  name: "PUNCH",
  fullName: "PROGÈRE PUNCH",
  subtitle: "MODULE DE L'ÉCOSYSTÈME PROGÈRE",
  icon: "Fingerprint",
  domain: "https://punch.progere.ca",
};
